var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.67 9.81V8.17c0-2.19-1.65-4.17-3.92-4.17h-9.5c-2.27 0-3.92 1.98-3.92 4.17V9.8h-5.1C7.22 9.81 5 12.47 5 15.46v4.04c0 3.31 1.69 4 5 4h2V23c0-2.76 1.24-4 4-4s4 1.24 4 4v.5h8V23c0-2.76 1.24-4 4-4s4 1.24 4 4v.5h2c3.31 0 5-.69 5-4v-4.04c0-2.99-2.22-5.65-5.23-5.65h-5.1ZM19.43 6.98c-.25 0-.64.26-.64.83v2H29.2v-2c0-.57-.4-.83-.64-.83h-9.14Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 25.57V26c0 2.76 1.24 4 4 4s4-1.24 4-4v-.43h2.76c2.9 0 4.24-.35 4.24-3.24v16.2c0 2.9-2.2 5.47-5.21 5.47H10.2C7.21 44 5 41.42 5 38.53v-16.2c0 2.9 1.35 3.24 4.24 3.24H12V26c0 2.76 1.24 4 4 4s4-1.24 4-4v-.43h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 23a2 2 0 1 1 4 0v3a2 2 0 1 1-4 0v-3Zm-16 0a2 2 0 1 1 4 0v3a2 2 0 1 1-4 0v-3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.d2609bb5738215ddbd19c66e033b98d9.svg";
export { ForwardRef as ReactComponent };